var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-data-table", {
        staticStyle: { "white-space": "nowrap" },
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          "hide-default-header": _vm.empty,
          height: _vm.items.length > 7 ? 32 * 7 + 32 + 16 : undefined,
          "disable-pagination": "",
          "hide-default-footer": "",
          dense: "",
        },
        scopedSlots: _vm._u(
          [
            _vm.toolbar
              ? {
                  key: "top",
                  fn: function () {
                    return [
                      _c(
                        "v-toolbar",
                        { attrs: { flat: "", dense: "" } },
                        [
                          _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                          _c("v-divider", {
                            staticClass: "mx-2",
                            attrs: { inset: "", vertical: "" },
                          }),
                          !_vm.readonly
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { small: "", color: "primary" },
                                  on: { click: _vm.row_create },
                                },
                                [_vm._v("Add")]
                              )
                            : _vm._e(),
                          _c("v-spacer"),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "item.started",
              fn: function ({ item }) {
                return [
                  _vm._v(" " + _vm._s(_vm.formatDate(item.started)) + " "),
                ]
              },
            },
            {
              key: "item.default",
              fn: function ({ item }) {
                return [
                  item.default
                    ? _c("v-icon", { attrs: { color: "green" } }, [
                        _vm._v("mdi-check-circle"),
                      ])
                    : _vm._e(),
                ]
              },
            },
            !_vm.readonly
              ? {
                  key: "item.actions",
                  fn: function ({ item }) {
                    return [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.row_update(item)
                            },
                          },
                        },
                        [_vm._v("mdi-pencil")]
                      ),
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.row_moveup(item)
                            },
                          },
                        },
                        [_vm._v("mdi-arrow-up-thick")]
                      ),
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.row_movedown(item)
                            },
                          },
                        },
                        [_vm._v("mdi-arrow-down-thick")]
                      ),
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.row_remove(item)
                            },
                          },
                        },
                        [_vm._v("mdi-delete")]
                      ),
                    ]
                  },
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c("r-smart-offer-skin-dialog", { ref: "dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }